import axios from 'axios';
import { MDBSpinner, MDBContainer, MDBCarousel, MDBCarouselItem, MDBIcon } from 'mdb-react-ui-kit';
import React, { useContext, useEffect,useState,useRef } from 'react';


import { MiscContext } from '../context/MiscProvider';
export default function Testimonials() {
  const { testimonials, setTestimonials, selectDomains } = useContext(MiscContext);
  const selectDomainsMap = new Map();
  selectDomains?.forEach(domain => {
    selectDomainsMap.set(domain.id, domain.name);
  });
  const domainId = localStorage.getItem("DOMAIN");
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const [loaded, setLoaded] = useState(false);
  const didFetchRef = useRef(false);
  useEffect(() => {
    
    if (!didFetchRef.current) {
      didFetchRef.current = true;
    axios.get(`${baseUrl}/reviews/testimonials/${domainId}`)
      .then(response => {
        setTestimonials(response?.data);
       
      })
      .catch(error => {
        console.error("Error fetching reviews:", error);
      });
      setLoaded(true);
    }
  }, []);

  

  useEffect(() => {
      if (testimonials && testimonials.reviewList?.length > 0) {
          setLoaded(true);
      }else{
        setLoaded(false);
      }
  }, [testimonials]); // Dependency on testimonials data




  return loaded ?  (


    <MDBContainer  className='text-center mt-5 rounded '>
{testimonials?.reviewList?.length >0 && <h3 className="mb-2">Testimonials</h3>}
  <MDBCarousel showControls showIndicators  dark keyboard>
          {testimonials?.reviewList?.map((review, index) => (
         <MDBCarouselItem itemId={index + 1} key={index}>
          {review.avatarImage && 
             <img 
                src={review.avatarImage} // Use the avatarImage from the API response
                style={{ height: '100px', width: '100px' }}
                className='rounded-circle'
                alt='...'
              />}
              <div className='testimonial mt-5'>
                <p>
                  {review.writeUp} {/* Use the writeUp from the API response */}
                </p>
                <h4 className='font-weight-bold'>{review.name}</h4> {/* Use review.name */}
                <h6 className='font-weight-bold my-3'>{selectDomainsMap.get(review.id)}</h6> {/* Use selectedDomains.get(review.id) */}
              
                <div>
                  {Array.from({ length: Math.floor(parseFloat(review.rate)) }).map((_, i) => (
                    <MDBIcon icon='star' className='text-warning' key={i} />
                  ))}
                  {Math.floor(parseFloat(review.rate)) !== parseFloat(review.rate) && (
                    <MDBIcon far icon='star-half' className='text-warning' />
                  )}
                </div>
              </div>
            </MDBCarouselItem>
          ))}
        </MDBCarousel>

</MDBContainer>


   
  ) : (<div/>);
}
